/* Article premium: turns plain blog HTML (in any language) into the styled reading layout. */
(() => {
  const body = document.querySelector('.ab-body');
  if (!body || body.dataset.abReady) return;
  body.dataset.abReady = '1';

  const ARROW = '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M3 8h9.5M8.5 4l4 4-4 4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const EXTERNAL = '<svg aria-hidden="true" width="13" height="13" viewBox="0 0 16 16" fill="none"><path d="M5.5 3.5h7v7M12.2 3.8 4 12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const LABEL_END = /[:：]\s*$/;
  const QUESTION_END = /[?？؟]\s*$/;
  // a version number ("EaseFlow 2.0", "since 1.1:") is never a step number
  const STEP = /^(\D{0,16}?)(\d{1,2})(?![.．,]\d)\s*[:：.．]\s*/;
  const SENTENCE_END = /[.!?:;。！？：；…।؟]\s*$/;
  const PREMIERE_ICON = 'https://cdn.shopify.com/s/files/1/0918/5126/0244/files/Adobe_Premiere_Pro_CC_icon.svg-3.png';
  const kids = () => Array.from(body.children);
  const scriptSrc = (document.currentScript && document.currentScript.src) || '';
  const assetBase = scriptSrc.replace(/article-premium\.js.*$/, '');
  const CARTRIDGES = ['betterfx', 'easeflow', 'quickpaste', 'mako'];
  const cartridge = (handle) => (CARTRIDGES.includes(handle) && assetBase ? `${assetBase}ab-cart-${handle}.png` : null);
  const isHeading = (el) => el && /^H[1-3]$/.test(el.tagName);

  const internalPath = (a) => {
    try {
      const url = new URL(a.getAttribute('href'), location.origin);
      return url.origin === location.origin ? url.pathname : null;
    } catch (e) {
      return null;
    }
  };

  const toButton = (a, ghost) => {
    if (a.classList.contains('ab-btn')) return;
    a.classList.add('ab-btn');
    if (ghost) a.classList.add('ab-btn--ghost');
    a.insertAdjacentHTML('beforeend', ghost ? EXTERNAL : ARROW);
  };

  // 1. Lead paragraph
  const first = body.firstElementChild;
  if (first && first.tagName === 'P' && !first.querySelector('img, iframe')) first.classList.add('ab-lead');

  // 2. Media: lone images and embedded videos
  body.querySelectorAll(':scope > p').forEach((p) => {
    const only = p.children.length === 1 && p.textContent.trim() === '';
    if (!only) return;
    const child = p.firstElementChild;
    if (child.tagName === 'IMG') p.classList.add('ab-figure');
    if (child.tagName === 'IFRAME') {
      p.classList.add('ab-video');
      child.removeAttribute('width');
      child.removeAttribute('height');
      child.setAttribute('loading', 'lazy');
    }
  });

  // 3. Numbered step headings ("Step 1: …" in any language)
  body.querySelectorAll(':scope > h2, :scope > h3').forEach((h) => {
    const text = h.textContent.trim();
    const m = text.match(STEP);
    if (!m || h.children.length) return;
    const rest = text.slice(m[0].length);
    if (!rest) return;
    h.classList.add('ab-step');
    h.setAttribute('aria-label', text);
    h.textContent = '';
    const num = document.createElement('span');
    num.className = 'ab-step__num';
    num.setAttribute('aria-hidden', 'true');
    const digits = document.createElement('i');
    digits.textContent = m[2];
    num.appendChild(digits);
    const label = document.createElement('span');
    label.setAttribute('aria-hidden', 'true');
    label.textContent = rest;
    h.append(num, label);
  });


  // topic icon for a tip/feature card: keyword match (store languages), neutral fallback
  function tipIcon(head, all, i) {
    // glyphs: Lucide (ISC licence, lucide.dev), drawn on a 24px grid
    const P = {
      search: '<circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/>',
      key: '<path d="M10 8h.01"/><path d="M12 12h.01"/><path d="M14 8h.01"/><path d="M16 12h.01"/><path d="M18 8h.01"/><path d="M6 8h.01"/><path d="M7 16h10"/><path d="M8 12h.01"/><rect width="20" height="16" x="2" y="4" rx="2"/>',
      layers: '<path d="m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z"/><path d="m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65"/><path d="m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65"/>',
      palette: '<circle cx="13.5" cy="6.5" r=".5" fill="currentColor"/><circle cx="17.5" cy="10.5" r=".5" fill="currentColor"/><circle cx="8.5" cy="7.5" r=".5" fill="currentColor"/><circle cx="6.5" cy="12.5" r=".5" fill="currentColor"/><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"/>',
      wave: '<path d="M2 10v3"/><path d="M6 6v11"/><path d="M10 3v18"/><path d="M14 8v7"/><path d="M18 5v13"/><path d="M22 10v3"/>',
      bolt: '<path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"/>',
      curve: '<circle cx="19" cy="5" r="2"/><circle cx="5" cy="19" r="2"/><path d="M5 17A12 12 0 0 1 17 5"/>',
      type: '<polyline points="4 7 4 4 20 4 20 7"/><line x1="9" x2="15" y1="20" y2="20"/><line x1="12" x2="12" y1="4" y2="20"/>',
      target: '<circle cx="12" cy="12" r="10"/><line x1="22" x2="18" y1="12" y2="12"/><line x1="6" x2="2" y1="12" y2="12"/><line x1="12" x2="12" y1="6" y2="2"/><line x1="12" x2="12" y1="22" y2="18"/>',
      download: '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" x2="12" y1="15" y2="3"/>',
      sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2v2"/><path d="M12 20v2"/><path d="m4.93 4.93 1.41 1.41"/><path d="m17.66 17.66 1.41 1.41"/><path d="M2 12h2"/><path d="M20 12h2"/><path d="m6.34 17.66-1.41 1.41"/><path d="m19.07 4.93-1.41 1.41"/>',
      cut: '<g transform="translate(0.5 0)"><circle cx="6" cy="6" r="3"/><path d="M8.12 8.12 12 12"/><path d="M20 4 8.12 15.88"/><circle cx="6" cy="18" r="3"/><path d="M14.8 14.8 20 20"/></g>',
      tag: '<path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"/><circle cx="7.5" cy="7.5" r=".5" fill="currentColor"/>',
      screen: '<rect width="20" height="14" x="2" y="3" rx="2"/><line x1="8" x2="16" y1="21" y2="21"/><line x1="12" x2="12" y1="17" y2="21"/>',
      chart: '<line x1="18" x2="18" y1="20" y2="10"/><line x1="12" x2="12" y1="20" y2="4"/><line x1="6" x2="6" y1="20" y2="14"/>',
      shield: '<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/>',
      clock: '<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>',
      image: '<rect width="18" height="18" x="3" y="3" rx="2" ry="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/>',
      camera: '<path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"/><circle cx="12" cy="13" r="3"/>',
      frame: '<path d="M3 7V5a2 2 0 0 1 2-2h2"/><path d="M17 3h2a2 2 0 0 1 2 2v2"/><path d="M21 17v2a2 2 0 0 1-2 2h-2"/><path d="M7 21H5a2 2 0 0 1-2-2v-2"/>',
      sparkle: '<path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/><path d="M20 3v4"/><path d="M22 5h-4"/><path d="M4 17v2"/><path d="M5 18H3"/>',
      wand: '<path d="m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72"/><path d="m14 7 3 3"/><path d="M5 6v4"/><path d="M19 14v4"/><path d="M10 2v2"/><path d="M7 8H3"/><path d="M21 16h-4"/><path d="M11 3H9"/>',
      check: '<circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/>',
      license: '<path d="M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z"/><circle cx="16.5" cy="7.5" r=".5" fill="currentColor"/>',
      cursor: '<g transform="translate(-0.5 -0.5)"><path d="M4.037 4.688a.495.495 0 0 1 .651-.651l16 6.5a.5.5 0 0 1-.063.947l-6.124 1.58a2 2 0 0 0-1.438 1.435l-1.579 6.126a.5.5 0 0 1-.947.063z"/></g>',
      help: '<circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/>',
      reverse: '<path d="M8 3 4 7l4 4"/><path d="M4 7h16"/><path d="m16 21 4-4-4-4"/><path d="M20 17H4"/>',
      corner: '<path d="M15.707 21.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414l5.586-5.586a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414z"/><path d="m18 13-1.375-6.874a1 1 0 0 0-.746-.776L3.235 2.028a1 1 0 0 0-1.207 1.207L5.35 15.879a1 1 0 0 0 .776.746L13 18"/><path d="m2.3 2.3 7.286 7.286"/><circle cx="11" cy="11" r="2"/>',
      star: '<g transform="translate(0 0.45)"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"/></g>'
    };
    const R = [
      ['reverse', /revers|mirror|flip|swap|backward|umkehr|spiegel|invers|inverti|omkeer|spegla|vend|käännä|反転|반전|反轉|ters çevir|đảo|balik|odwr|عكس|उलट/],
      ['license', /licen[cs]|lizenz|serial|activation|aktivier|activa|attiva|activer|aktiver|aktivo|lisen|ライセンス|라이선스|라이센스|授權|许可|lisans|giấy phép|klucz|ترخيص|लाइसेंस|licença/],
      ['camera', /camera|shoot|film|footage|record|4k|resolution|quality|kamera|aufnahm|auflösung|qualität|caméra|filmer|résolution|qualité|cámara|grabar|resolución|calidad|fotocamera|risoluzione|qualità|opnemen|resolutie|kwaliteit|upplösning|kvalitet|optag|opløsning|tarkkuus|laatu|カメラ|撮影|解像度|画質|카메라|촬영|해상도|화질|攝影|拍攝|解析度|畫質|çekim|çözünürlük|kalite|quay|độ phân giải|chất lượng|rekam|resolusi|kualitas|nagrywa|rozdzielczo|jakoś|كاميرا|تصوير|دقة|جودة|कैमरा|रिकॉर्ड|câmera|gravar|resolução|qualidade/],
      ['frame', /zoom|scale|crop|frame|edge|border|position|skalier|zuschn|kante|échelle|recadr|bord|escala|recort|borde|scala|ritagl|bordo|schaal|bijsnij|skala|beskär|beskær|skaala|rajaa|reuna|ズーム|スケール|切り抜|端|줌|스케일|가장자리|縮放|裁切|邊緣|yakınlaş|ölçek|kırp|kenar|phóng to|tỷ lệ|viền|perbesar|tepi|powiększ|kadr|krawęd|تكبير|اقتصاص|حافة|ज़ूम|स्केल|क्रॉप|किनार|cortar|borda/],
      ['palette', /appearance|theme|profile|dark mode|look and feel|erscheinung|darstellung|profil|apparence|thème|apariencia|tema|perfil|aspetto|profilo|weergave|uiterlijk|utseende|udseende|ulkoasu|teema|外観|テーマ|プロフィール|외관|테마|프로필|外觀|主題|görünüm|giao diện|hồ sơ|tampilan|wygląd|motyw|المظهر|السمة|रूप|थीम|aparência/],
      ['search', /search|find|such|finde|cherch|trouv|busc|encuentr|ricerc|trova|zoek|vind|sök|hitta|søg|find|hae|löyd|検索|探|검색|찾|搜尋|尋找|ara|bul|tìm|cari|temukan|szuk|znajd|بحث|ابحث|खोज/],
      ['key', /shortcut|keyboard|hotkey|tastatur|tastenk|kürzel|raccourci|clavier|atajo|teclado|scorciatoi|tastiera|sneltoets|toetsenbord|kortkommando|tangentbord|genvej|tastatur|pikanäp|näppäim|ショートカット|キー|단축|키보드|快捷|鍵盤|kısayol|klavye|phím tắt|bàn phím|pintasan|keyboard|skrót|klawiatur|اختصار|لوحة المفاتيح|शॉर्टकट|कीबोर्ड|tecla|atalho/],
      ['palette', /colou?r|lumetri|grade|grading|farb|couleur|étalonn|colore|kleur|färg|farve|väri|色|색|renk|màu|warna|kolor|لون|ألوان|रंग|cor\b|cores/],
      ['wave', /audio|sound|voice|music|beat|song|ton\b|stimme|musik|son\b|voix|musique|sonido|voz|música|suono|voce|musica|geluid|stem|muziek|ljud|röst|lyd|stemme|ääni|musiikki|音|声|소리|오디오|음악|목소리|聲|ses\b|müzik|âm thanh|giọng|nhạc|suara|musik|dźwięk|głos|muzyk|صوت|موسيقى|ऑडियो|आवाज़|संगीत|áudio|som\b/],
      ['curve', /keyframe|eas(e|ing)|curve|smooth|motion|animat|bewegung|kurve|courbe|fluide|curva|suave|movimiento|fluido|vloeiend|kromme|kurva|mjuk|blød|käyrä|pehme|イージング|カーブ|滑らか|이징|커브|부드러|緩動|曲線|平滑|eğri|akıcı|đường cong|mượt|kurva|halus|krzyw|płynn|منحنى|سلس|कर्व|स्मूद/],
      ['type', /\btext|title|caption|subtitle|font|word|schrift|untertit|texte|sous-titr|police|texto|subtítul|testo|sottotitol|tekst|ondertitel|undertext|teksti|tekstitys|テキスト|字幕|文字|텍스트|자막|글꼴|文字|metin|altyazı|văn bản|phụ đề|teks|subjudul|napis|نص|ترجمة|टेक्स्ट|सबटाइटल|legenda/],
      ['target', /mask|track|focus|maske|masque|máscara|maschera|masker|mask|naamio|マスク|トラック|마스크|트래킹|遮罩|追蹤|maske|mặt nạ|masker|maska|قناع|मास्क/],
      ['download', /export|render|save|download|exportier|speicher|exporter|enregistr|exportar|guardar|esportare|salvare|exporteren|opslaan|exportera|spara|eksport|gem\b|vie\b|tallenn|書き出|保存|내보내|저장|匯出|儲存|dışa aktar|kaydet|xuất|lưu|ekspor|simpan|eksport|zapis|تصدير|حفظ|एक्सपोर्ट|सेव/],
      ['sun', /blur|glow|light|shine|bright|flash|leucht|licht|unschärf|lueur|lumière|flou|brillo|luz|desenfoque|bagliore|luce|sfocatur|gloed|vervag|ljus|sken|oskärp|lys|uskarp|hehku|valo|sumen|グロー|光|ぼかし|글로우|빛|블러|光暈|模糊|parlama|ışık|bulanık|phát sáng|ánh sáng|làm mờ|cahaya|kabur|blask|światł|rozmyc|توهج|ضوء|تمويه|ग्लो|रोशनी|ब्लर|desfoque|brilho/],
      ['cut', /\bcut|trim|split|razor|schneid|schnitt|couper|coupe|tagli|knip|klipp|leikk|カット|컷|剪|kes\b|cắt|potong|przytn|قص|कट/],
      ['tag', /free|price|cost|kostenlos|gratuit|gratis|gratuito|gratuita|ilmai|無料|価格|무료|가격|免費|價格|ücretsiz|fiyat|miễn phí|giá|gratis|harga|darmow|cena|مجان|سعر|मुफ़्त|कीमत|preço/],
      ['screen', /mac\b|windows|install|compat|version|update|panel|installier|kompatib|installer|instalar|compatib|installare|installeren|installera|installer|asenn|インストール|対応|設치|호환|安裝|相容|kurulum|uyumlu|cài đặt|tương thích|instal|kompatib|instal|zgodn|تثبيت|متوافق|इंस्टॉल|संगत/],
      ['chart', /rank|usage|most.used|recent|history|statist|verlauf|zuletzt|historique|récent|historial|reciente|cronologi|recent|geschiedenis|recent|historik|senaste|historik|seneste|historia|viimeis|履歴|最近|기록|최근|歷史|最近|geçmiş|son kull|lịch sử|gần đây|riwayat|terbaru|histori|ostatni|سجل|الأخيرة|इतिहास|हाल/],
      ['layers', /batch|layer|stack|preset|multiple|several|adjustment|ebene|stapel|vorgabe|mehrere|calque|lot|plusieurs|préréglage|capa|lote|varios|ajuste preestablecido|livell|più clip|predefinit|laag|meerdere|voorinstel|lager|flera|förinställ|flere|forudindst|taso|useita|esiasetu|レイヤー|一括|プリセット|복수|레이어|프리셋|일괄|圖層|批次|預設|katman|toplu|ön ayar|lớp|hàng loạt|cài đặt sẵn|lapisan|sekaligus|preset|warstw|wiele|ustawie|طبقة|دفعة|إعداد مسبق|लेयर|प्रीसेट|camada|predefini/],
      ['shield', /never overwrit|safe|undo|overwrit|sicher|rückgäng|überschreib|sûr|annuler|écras|segur|deshacer|sobrescrib|sicur|annull|sovrascriv|veilig|ongedaan|overschrijf|säker|ångra|skriv över|sikker|fortryd|overskriv|turvall|kumoa|korvaa|安全|元に戻|上書き|안전|실행 취소|덮어|安全|復原|覆蓋|güvenli|geri al|üzerine yaz|an toàn|hoàn tác|ghi đè|aman|urungkan|timpa|bezpiecz|cofnij|nadpis|آمن|تراجع|الكتابة فوق|सुरक्षित|अनडू|सुरक्षा|seguro|desfazer|sobrescrev/],
      ['clock', /time|second|minute|hour|zeit|sekund|minut|temps|seconde|tiempo|segundo|minuto|tempo|tijd|seconde|tid|sekund|aika|sekunti|時間|秒|分|시간|초|분|時間|秒|zaman|saniye|thời gian|giây|waktu|detik|czas|sekund|وقت|ثانية|समय|सेकंड/],
      ['image', /image|photo|picture|screenshot|png|jpg|bild|foto|grafik|photo|imagen|immagine|afbeelding|bild|billede|kuva|画像|写真|이미지|사진|圖片|照片|görsel|resim|fotoğraf|hình ảnh|ảnh|gambar|obraz|zdjęci|صورة|इमेज|फोटो|imagem/],
      ['corner', /corner|sharp|ecke|coin|esquina|angolo|hoek|hörn|hjørne|kulma|角|모서리|köşe|góc|sudut|narożn|زاوية|कोना|canto/],
      ['help', /help|guide|how to|tutorial|tooltip|hilfe|anleitung|aide|ayuda|guía|aiuto|guida|hulp|hjälp|hjælp|ohje|ヘルプ|ガイド|도움말|가이드|說明|幫助|yardım|rehber|trợ giúp|hướng dẫn|bantuan|panduan|pomoc|przewodnik|مساعدة|دليل|मदद|गाइड|ajuda/],
      ['cursor', /click|drag|mouse|cursor|right-click|menu|klick|ziehen|cliqu|glisser|clic|arrastr|trascin|klik|slepen|dra |klikk|vedä|クリック|ドラッグ|メニュー|클릭|드래그|메뉴|點擊|拖|選單|tıkla|sürükle|nhấp|kéo|seret|przeciąg|انقر|اسحب|क्लिक|ड्रैग/],
      ['bolt', /fast|quick|speed|instant|one.click|schnell|sofort|rapide|vite|instantan|rápid|velocidad|veloc|rapid|istantan|snel|direct|snabb|direkt|hurtig|nopea|heti|速|すぐ|빠르|즉시|快|立即|hızlı|anında|nhanh|tức thì|cepat|instan|szybk|natychmiast|سريع|فوري|तेज़|तुरंत/]
    ];
    let key = null;
    const t = (head || '').toLowerCase();
    for (const [k, re] of R) { if (re.test(t)) { key = k; break; } }
    if (!key) key = ['sparkle', 'wand', 'check', 'star', 'layers', 'bolt'][i % 6];
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">' + P[key] + '</svg>';
  }

  // 4. Tip lists: every item opens with a bold lead-in
  body.querySelectorAll(':scope > ul').forEach((ul) => {
    const items = Array.from(ul.children);
    if (items.length > 1 && items.every((li) => li.firstElementChild && li.firstElementChild.tagName === 'STRONG' && li.textContent.trim().startsWith(li.firstElementChild.textContent.trim()))) {
      ul.classList.add('ab-tips');
      let short = true;
      items.forEach((li, i) => {
        const lead = li.querySelector(':scope > strong');
        if (!lead) return;
        const rest = document.createElement('span');
        rest.className = 'ab-tips__rest';
        while (lead.nextSibling) rest.appendChild(lead.nextSibling);
        const restText = rest.textContent.trim();
        if (restText.length > 110) short = false;
        // a bold lead-in that is a whole sentence ("Sharp corners.") becomes the title; one that
        // runs on into the sentence ("The Multi-Point library, with 14 new moves") stays inline
        const inline = restText !== '' && !SENTENCE_END.test(lead.textContent);
        if (!inline) {
          const t = rest.firstChild;
          if (t && t.nodeType === 3) t.textContent = t.textContent.replace(/^\s+/, '');
        }
        const ico = document.createElement('span');
        ico.className = 'ab-tips__icon';
        ico.setAttribute('aria-hidden', 'true');
        const head = lead.textContent;
        if (/premiere/i.test(head) && /\b20\d\d\b/.test(head)) {
          ico.classList.add('ab-tips__icon--app');
          ico.innerHTML = `<img src="${PREMIERE_ICON}" alt="" width="44" height="44" loading="lazy">`;
        } else {
          ico.innerHTML = tipIcon(head, li.textContent, i);
        }
        const text = document.createElement('div');
        text.className = 'ab-tips__text' + (inline ? ' ab-tips__text--inline' : '');
        if (!restText) text.classList.add('ab-tips__text--solo');
        text.append(lead, rest);
        li.textContent = '';
        li.append(ico, text);
      });
      // two to four short tips sit side by side as tiles; longer lists become one grouped panel
      const n = items.length;
      if (short && n <= 4 && !ul.querySelector('.ab-tips__text--inline, .ab-tips__text--solo')) {
        ul.classList.add('ab-tips--grid', `ab-tips--${n === 3 ? 3 : 2}`);
      } else {
        ul.classList.add('ab-tips--list');
      }
    }
  });

  // 5. FAQ: an H2 followed by question H3s becomes an accordion
  kids().forEach((h2) => {
    if (h2.tagName !== 'H2') return;
    const groups = [];
    let el = h2.nextElementSibling;
    while (el && el.tagName === 'H3' && QUESTION_END.test(el.textContent)) {
      const answer = [];
      let next = el.nextElementSibling;
      while (next && !isHeading(next)) {
        answer.push(next);
        next = next.nextElementSibling;
      }
      groups.push({ q: el, answer });
      el = next;
    }
    if (groups.length < 2) return;
    // the section ends at the last question: anything after its first answer
    // paragraph (closing lines, calls to action) stays in the article
    const lastGroup = groups[groups.length - 1];
    if (!el && lastGroup.answer.length > 1) lastGroup.answer = lastGroup.answer.slice(0, 1);
    const faq = document.createElement('div');
    faq.className = 'ab-faq';
    groups.forEach(({ q, answer }, i) => {
      const details = document.createElement('details');
      if (i === 0) details.open = true;
      const summary = document.createElement('summary');
      const qText = document.createElement('span');
      qText.setAttribute('role', 'heading');
      qText.setAttribute('aria-level', '3');
      qText.textContent = q.textContent.trim();
      const icon = document.createElement('span');
      icon.className = 'ab-faq__icon';
      icon.setAttribute('aria-hidden', 'true');
      summary.append(qText, icon);
      const panel = document.createElement('div');
      panel.className = 'ab-faq__panel';
      const wrap = document.createElement('div');
      wrap.className = 'ab-faq__answer';
      answer.forEach((n) => wrap.appendChild(n));
      panel.appendChild(wrap);
      details.append(summary, panel);
      faq.appendChild(details);
      q.remove();
    });
    h2.after(faq);
  });

  // 6. Cards: an H3 followed by "Label: value" paragraphs
  kids().forEach((h3) => {
    if (h3.tagName !== 'H3' || !h3.parentElement || h3.parentElement !== body) return;
    const members = [];
    let el = h3.nextElementSibling;
    while (el && !isHeading(el) && !el.classList.contains('ab-faq')) {
      members.push(el);
      el = el.nextElementSibling;
    }
    const isSpec = (p) => {
      const s = p.tagName === 'P' && p.firstElementChild;
      return s && s.tagName === 'STRONG' && p.textContent.trim().startsWith(s.textContent.trim()) && LABEL_END.test(s.textContent);
    };
    if (!members.some(isSpec)) return;

    const card = document.createElement('section');
    card.className = 'ab-card';
    const head = document.createElement('div');
    head.className = 'ab-card__head';
    h3.before(card);
    head.appendChild(h3);
    card.appendChild(head);

    members.forEach((p) => {
      card.appendChild(p);
      if (!isSpec(p)) return;
      p.classList.add('ab-spec');
      const strong = p.firstElementChild;
      const label = document.createElement('span');
      label.className = 'ab-spec__label';
      label.textContent = strong.textContent.replace(LABEL_END, '').trim();
      strong.remove();
      const value = document.createElement('span');
      value.className = 'ab-spec__value';
      while (p.firstChild) value.appendChild(p.firstChild);
      p.append(label, value);
      value.querySelectorAll('a').forEach((a) => {
        const path = internalPath(a);
        toButton(a, !path);
        if (!a.previousSibling || a.previousSibling.nodeType !== 1 || a.previousSibling.tagName !== 'BR') a.before(document.createElement('br'));
      });
    });

    // product thumbnail for our own products
    const productLink = card.querySelector('a[href*="/products/"]');
    const path = productLink && internalPath(productLink);
    const handle = path && (path.match(/\/products\/([^/?#]+)/) || [])[1];
    if (handle && cartridge(handle)) {
      const thumb = document.createElement('div');
      thumb.className = 'ab-card__thumb ab-card__thumb--cart';
      const img = document.createElement('img');
      img.src = cartridge(handle); img.alt = ''; img.width = 72; img.height = 80; img.loading = 'lazy';
      thumb.appendChild(img);
      head.prepend(thumb);
    } else if (handle) {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(`${root}products/${handle}.js`, { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null))
        .then((product) => {
          const src = product && (product.featured_image || (product.images && product.images[0]));
          if (!src) return;
          const thumb = document.createElement('div');
          thumb.className = 'ab-card__thumb';
          const img = document.createElement('img');
          const url = src.startsWith('//') ? `https:${src}` : src;
          img.src = url + (url.includes('?') ? '&' : '?') + 'width=240';
          img.alt = '';
          img.width = 76;
          img.height = 76;
          img.loading = 'lazy';
          thumb.appendChild(img);
          head.prepend(thumb);
        })
        .catch(() => {});
    }
  });

  // 6b. Product tips: a standalone "Label:" paragraph that links to one of our products
  const lang = document.documentElement.lang || undefined;
  body.querySelectorAll(':scope > p').forEach((p) => {
    const strong = p.firstElementChild;
    if (!strong || strong.tagName !== 'STRONG' || !LABEL_END.test(strong.textContent) || !p.textContent.trim().startsWith(strong.textContent.trim())) return;
    const link = p.querySelector('a[href*="/products/"]');
    const path = link && internalPath(link);
    const handle = path && (path.match(/\/products\/([^/?#]+)/) || [])[1];
    if (!handle) return;
    p.classList.add('ab-tip');
    strong.classList.add('ab-tip__label');
    strong.textContent = strong.textContent.replace(LABEL_END, '').trim();
    const copy = document.createElement('span');
    copy.className = 'ab-tip__copy';
    while (strong.nextSibling) copy.appendChild(strong.nextSibling);
    // the sentence now starts on its own line, so it starts with a capital letter
    const first = copy.firstChild;
    if (first && first.nodeType === 3) {
      const t = first.textContent.replace(/^\s+/, '');
      first.textContent = t.charAt(0).toLocaleUpperCase(lang) + t.slice(1);
    }
    link.classList.add('ab-tip__link');
    link.insertAdjacentHTML('beforeend', ARROW);
    const text = document.createElement('div');
    text.className = 'ab-tip__text';
    text.append(strong, copy);
    p.appendChild(text);
    const icon = document.createElement('div');
    icon.className = 'ab-tip__icon';
    const img = document.createElement('img');
    img.alt = '';
    img.width = 56;
    img.height = 56;
    img.loading = 'lazy';
    icon.appendChild(img);
    if (cartridge(handle)) {
      img.src = cartridge(handle);
      icon.classList.add('ab-tip__icon--cart');
      p.prepend(icon);
      return;
    }
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(`${root}products/${handle}.js`, { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .then((product) => {
        const src = product && (product.featured_image || (product.images && product.images[0]));
        if (!src) return;
        const url = src.startsWith('//') ? `https:${src}` : src;
        img.src = url + (url.includes('?') ? '&' : '?') + 'width=160';
        icon.classList.add('ab-tip__icon--product');
        p.prepend(icon);
      })
      .catch(() => {});
  });

  // 7. Closing call to action: final paragraph that links to our products or collections.
  // The card keeps the paragraph's opening sentence (usually a question) as a title of at most
  // two lines (else the product's short question from snippets/ab-cta-q), a one-line button and
  // the linked product's picture.
  const last = body.lastElementChild;
  if (last && last.tagName === 'P') {
    const links = last.querySelectorAll('a');
    const path = links.length === 1 && internalPath(links[0]);
    if (path && /\/(collections|products)\//.test(path)) {
      const a = links[0];
      const full = last.textContent.replace(/\s+/g, ' ').trim();
      const sentence = (full.match(/^[\s\S]*?(?:[?!？！؟。]|\.(?=\s|$))/) || [full])[0].trim();
      const text = sentence === a.textContent.trim() ? '' : sentence.replace(/[.。]$/, '');
      const cta = document.createElement('div');
      cta.className = 'ab-cta';
      const t = document.createElement('p');
      t.className = 'ab-cta__text';
      cta.appendChild(t);
      const longLabel = a.textContent.trim();
      toButton(a, false);
      cta.appendChild(a);
      // the linked product's picture (rendered by the section), so the card reads as a product at a glance
      const target = path.match(/\/(products|collections)\/([^/]+)/);
      const media = document.querySelector('template.ab-cta-media');
      let shortLabel = '';
      let question = '';
      if (target && media && media.dataset.kind === target[1] && media.dataset.handle === decodeURIComponent(target[2])) {
        cta.classList.add('ab-cta--media');
        shortLabel = media.dataset.label || '';
        question = media.dataset.question || '';
        cta.appendChild(media.content.cloneNode(true));
      }
      last.replaceWith(cta);

      const setLabel = (label) => {
        a.textContent = label;
        a.insertAdjacentHTML('beforeend', ARROW);
      };
      if (shortLabel) a.setAttribute('aria-label', longLabel);
      const lines = () => Math.round(t.offsetHeight / parseFloat(getComputedStyle(t).lineHeight));
      // a title fits when it takes two lines at most, a touch smaller if needed
      const tryTitle = (title) => {
        if (!title) return false;
        t.textContent = title;
        t.style.fontSize = '';
        let size = parseFloat(getComputedStyle(t).fontSize);
        const min = size * 0.92;
        while (lines() > 2 && size > min) {
          size -= 0.5;
          t.style.fontSize = `${size}px`;
        }
        return lines() <= 2;
      };
      const fit = () => {
        // button: one line, else the short label ("Browse all", "Get it free")
        setLabel(longLabel);
        if (shortLabel && a.scrollWidth > a.clientWidth + 1) setLabel(shortLabel);
        // title: the post's own opening sentence, else the product's short question, else none
        t.hidden = false;
        const ok = tryTitle(text) || tryTitle(question);
        t.hidden = !ok;
        cta.classList.toggle('ab-cta--bare', !ok);
      };
      fit();
      if (document.fonts) document.fonts.ready.then(fit);
      if ('ResizeObserver' in window) {
        let w = cta.clientWidth;
        new ResizeObserver(() => {
          if (cta.clientWidth === w) return;
          w = cta.clientWidth;
          fit();
        }).observe(cta);
      }
    }
  }

  // 8. Reading progress from the page top: eases towards the scroll position, fades in on first scroll
  const bar = document.querySelector('.ab-progress');
  if (bar) {
    const header = document.querySelector('sticky-header, header.header');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let target = 0;
    let current = 0;
    let raf = 0;
    // the line runs from the very top of the page to the end of the article.
    // It stays hidden until the reader first moves away from the top, then
    // fades in; it fades out again once the article has been read.
    const measure = () => {
      const top = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
      if (bar.style.top !== `${top}px`) bar.style.top = `${top}px`;
      const y = window.scrollY;
      const vh = window.innerHeight;
      const endY = body.getBoundingClientRect().bottom + y - vh * 0.75;
      target = Math.min(1, Math.max(0, y / Math.max(endY, 1)));
      bar.classList.toggle('is-visible', y > 2 && y < endY + vh * 0.5);
    };
    const tick = () => {
      current = reduce ? target : current + (target - current) * 0.14;
      if (Math.abs(target - current) < 0.0005) current = target;
      bar.style.setProperty('--ab-p', current.toFixed(4));
      raf = current === target ? 0 : requestAnimationFrame(tick);
    };
    const onScroll = () => {
      measure();
      if (!raf) raf = requestAnimationFrame(tick);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }

  // 9. FAQ: same motion as the product-page FAQ. The unpadded panel's height
  // eases; the answer fades and settles in just after it starts opening, and
  // fades out quickly ahead of the collapse. Clicking mid-animation reverses
  // smoothly from wherever it is.
  const faqMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  body.querySelectorAll('.ab-faq details').forEach((d) => {
    const summary = d.querySelector('summary');
    const panel = d.querySelector('.ab-faq__panel');
    const answer = panel && panel.firstElementChild;
    if (!summary || !panel) return;
    const item = { expanded: d.open, animation: null, content: null };
    d.dataset.expanded = String(d.open);
    summary.setAttribute('aria-expanded', String(d.open));
    const settle = () => {
      item.animation && item.animation.cancel();
      item.animation = null;
      item.content && item.content.cancel();
      item.content = null;
      d.open = item.expanded;
      panel.inert = false;
    };
    const setExpanded = (expanded) => {
      if (expanded === item.expanded && !item.animation) return;
      const from = d.open ? panel.getBoundingClientRect().height : 0;
      const fromOpacity = answer && d.open ? parseFloat(getComputedStyle(answer).opacity) : 0;
      item.animation && item.animation.cancel();
      item.animation = null;
      item.content && item.content.cancel();
      item.content = null;
      item.expanded = expanded;
      d.dataset.expanded = String(expanded);
      summary.setAttribute('aria-expanded', String(expanded));
      panel.inert = !expanded;
      d.open = true;
      const to = expanded ? panel.scrollHeight : 0;
      if (faqMotion.matches || !panel.animate || Math.abs(from - to) < 1) { settle(); return; }
      const animation = panel.animate(
        [{ height: from + 'px' }, { height: to + 'px' }],
        expanded
          ? { duration: 460, easing: 'cubic-bezier(.22, 1, .36, 1)' }
          : { duration: 420, easing: 'cubic-bezier(.45, 0, .25, 1)' }
      );
      item.animation = animation;
      if (answer) {
        item.content = expanded
          ? answer.animate([
            { opacity: fromOpacity, transform: 'translateY(' + (-6 * (1 - fromOpacity)) + 'px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ], { duration: 400, delay: fromOpacity > 0 ? 0 : 60, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'backwards' })
          : answer.animate([
            { opacity: fromOpacity || 1, transform: 'translateY(0)' },
            { opacity: 0, transform: 'translateY(-4px)' }
          ], { duration: 240, easing: 'cubic-bezier(.25, .1, .25, 1)', fill: 'forwards' });
      }
      animation.onfinish = () => { if (item.animation === animation) settle(); };
    };
    summary.addEventListener('click', (e) => {
      if (e.button > 0) return;
      e.preventDefault();
      setExpanded(!item.expanded);
    });
    d.addEventListener('toggle', () => {
      if (item.animation) return;
      item.expanded = d.open;
      d.dataset.expanded = String(d.open);
      summary.setAttribute('aria-expanded', String(d.open));
    });
  });

})();

/* copy-link button at the end of the share row */
(() => {
  const share = document.querySelector('.template-article .ab-share[data-url]');
  const list = share && share.querySelector('.social-sharing');
  if (!list || list.querySelector('.ab-copy')) return;
  const label = share.dataset.copy || 'Copy link';
  const done = share.dataset.copied || 'Link copied';
  const url = share.dataset.url || location.href.split('#')[0];
  const li = document.createElement('li');
  li.innerHTML =
    '<button type="button" class="social-sharing__link ab-copy">' +
      '<svg class="ab-copy__link" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 13.5a4.5 4.5 0 0 0 6.4.2l3-3a4.5 4.5 0 0 0-6.4-6.4l-1.2 1.2"/><path d="M14 10.5a4.5 4.5 0 0 0-6.4-.2l-3 3a4.5 4.5 0 0 0 6.4 6.4l1.2-1.2"/></svg>' +
      '<svg class="ab-copy__check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>' +
      '<span class="ab-copy__tip" role="status" aria-live="polite"></span>' +
    '</button>';
  const btn = li.firstChild;
  const tip = btn.querySelector('.ab-copy__tip');
  btn.setAttribute('aria-label', label);
  btn.title = label;
  list.appendChild(li);

  const fallback = () => {
    const ta = document.createElement('textarea');
    ta.value = url;
    ta.setAttribute('readonly', '');
    ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0';
    document.body.appendChild(ta);
    ta.select();
    let ok = false;
    try { ok = document.execCommand('copy'); } catch (e) {}
    ta.remove();
    return ok;
  };
  let timer;
  btn.addEventListener('click', async () => {
    let ok = false;
    try { await navigator.clipboard.writeText(url); ok = true; } catch (e) { ok = fallback(); }
    if (!ok) return;
    tip.textContent = done;
    btn.classList.remove('is-copied');
    void btn.offsetWidth;
    btn.classList.add('is-copied');
    clearTimeout(timer);
    timer = setTimeout(() => { btn.classList.remove('is-copied'); tip.textContent = ''; }, 1800);
  });
})();

/* images and videos ease up and in as they scroll into view; text stays put */
(() => {
  const body = document.querySelector('.ab-body');
  if (!body || !('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const items = Array.from(body.querySelectorAll('.ab-figure, .ab-video'));
  if (!items.length) return;
  const vh = window.innerHeight;
  items.forEach((el) => {
    // anything already on screen at load stays as it is
    if (el.getBoundingClientRect().top < vh * 0.92) return;
    el.classList.add('ab-reveal');
  });
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
  items.forEach((el) => el.classList.contains('ab-reveal') && io.observe(el));
})();

/* reader-friendly paragraphs: long paragraphs are split into chunks of about two
   sentences (runs after the article has been structured, so FAQ answers and
   cards keep their paragraphs). Works on the rendered text in every language. */
(() => {
  const body = document.querySelector('.ab-body');
  if (!body) return;
  // Chinese/Japanese/Korean carry far more per character, so their limits are lower
  const dense = /^(ja|zh|ko)/i.test(document.documentElement.lang || '');
  const MIN_SPLIT = dense ? 130 : 300;   // only paragraphs longer than this are split
  const TARGET = dense ? 85 : 200;       // aim for chunks of roughly this many characters
  const cased = (ch) => ch.toLowerCase() !== ch.toUpperCase();
  // sentence ends: . ! ? … followed by space and a capital (or a caseless script),
  // or the CJK/Devanagari full stops, which need no space
  const boundaries = (text) => {
    const out = [];
    const re = /([.!?…؟।]["”’)»]?)(\s+)|([。！？])/g;
    let m;
    while ((m = re.exec(text))) {
      if (m[3]) { out.push(m.index + m[0].length); continue; }
      const next = text.charAt(m.index + m[0].length);
      if (!next) continue;
      if (!cased(next) || next === next.toUpperCase()) out.push(m.index + m[1].length + m[2].length);
    }
    return out;
  };
  body.querySelectorAll('p').forEach((p) => {
    if (p.className || p.closest('.ab-card, .ab-cta, .ab-share, .ab-tips') || p.querySelector('img, iframe, video, br')) return;
    const total = p.textContent.trim().length;
    if (total < MIN_SPLIT) return;
    // collect cut points as (text node, offset) in reading order, only in text
    // that sits directly in the paragraph (never inside links or bold text)
    const cuts = [];
    let seen = 0;
    Array.from(p.childNodes).forEach((n) => {
      if (n.nodeType === 3) boundaries(n.textContent).forEach((o) => cuts.push({ node: n, offset: o, at: seen + o }));
      seen += n.textContent.length;
    });
    if (!cuts.length) return;
    // choose cuts so each chunk is near TARGET and no chunk is tiny
    const chosen = [];
    let last = 0;
    let sentences = 0;
    cuts.forEach((c) => {
      sentences += 1;
      const len = c.at - last;
      if ((len >= TARGET || (sentences >= 2 && len >= TARGET * 0.6)) && seen - c.at >= (dense ? 30 : 70)) {
        chosen.push(c);
        last = c.at;
        sentences = 0;
      }
    });
    if (!chosen.length) return;
    // split from the end so earlier offsets stay valid
    const frag = [];
    let tail = p;
    for (let i = chosen.length - 1; i >= 0; i -= 1) {
      const { node, offset } = chosen[i];
      const after = node.splitText(offset);
      after.textContent = after.textContent.replace(/^\s+/, '');
      node.textContent = node.textContent.replace(/\s+$/, '');
      const np = document.createElement('p');
      let n = after;
      while (n) { const next = n.nextSibling; np.appendChild(n); n = next; }
      frag.unshift(np);
    }
    tail.after(...frag);
  });
})();

/* section bands: each H2 section (all the Step sections count as one) gets its
   own full-width band, alternating between the page black and a slightly lighter
   tone, so it is easy to tell where you are. */
(() => {
  const body = document.querySelector('.ab-body');
  if (!body) return;
  const nodes = Array.from(body.children);
  if (!nodes.some((n) => n.tagName === 'H2')) return;
  const groups = [];
  let cur = null;
  let curIsSteps = false;
  nodes.forEach((n) => {
    if (n.tagName === 'H2') {
      const isStep = n.classList.contains('ab-step');
      // steps continue the steps band, and also join a short lead-in section
      // right before them (e.g. "How to use it" + one sentence)
      const joinsLeadIn = isStep && cur && !curIsSteps && cur[0].tagName === 'H2' && cur.length <= 3;
      if (!(isStep && (curIsSteps || joinsLeadIn))) {
        cur = [];
        groups.push(cur);
      }
      curIsSteps = isStep;
    } else if (!cur) {
      cur = [];
      groups.push(cur);
      curIsSteps = false;
    }
    cur.push(n);
  });
  groups.forEach((g, i) => {
    const sec = document.createElement('section');
    sec.className = 'ab-sec' + (i % 2 ? ' ab-sec--alt' : '');
    if (g[0].tagName === 'H2' && g[0].classList.contains('ab-step')) sec.classList.add('ab-sec--steps');
    g[0].before(sec);
    g.forEach((n) => sec.appendChild(n));
  });
  body.classList.add('has-sections');
})();

/* structured data: FAQPage from the article's FAQ (in the page language) */
(() => {
  const items = Array.from(document.querySelectorAll('.ab-body .ab-faq details'));
  if (items.length < 2 || document.querySelector('script[data-ab-faq-ld]')) return;
  const clean = (s) => s.replace(/\s+/g, ' ').trim();
  const data = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((d) => {
      const q = d.querySelector('summary [role="heading"]') || d.querySelector('summary');
      const a = d.querySelector('.ab-faq__answer');
      return {
        '@type': 'Question',
        name: clean(q ? q.textContent : ''),
        acceptedAnswer: { '@type': 'Answer', text: clean(a ? a.textContent : '') }
      };
    }).filter((x) => x.name && x.acceptedAnswer.text)
  };
  if (data.mainEntity.length < 2) return;
  const s = document.createElement('script');
  s.type = 'application/ld+json';
  s.setAttribute('data-ab-faq-ld', '');
  s.textContent = JSON.stringify(data);
  document.head.appendChild(s);
})();

/* comparison tables: wrap for sideways scrolling and mark the Adobe Basics column */
(() => {
  const ours = /^(BetterFX|EaseFlow|QuickPaste|Mako)\b/;
  document.querySelectorAll('.ab-body table').forEach((t) => {
    if (t.parentElement.classList.contains('ab-table')) return;
    const wrap = document.createElement('div');
    wrap.className = 'ab-table';
    t.before(wrap);
    wrap.appendChild(t);
    const head = t.querySelector('thead tr') || t.querySelector('tr');
    if (!head) return;
    /* two-column lists (e.g. language + code) fit the phone instead of scrolling sideways */
    if (head.children.length <= 2) wrap.classList.add('ab-table--fit');
    const idx = Array.from(head.children).findIndex((c) => ours.test(c.textContent.trim()));
    if (idx < 1) return;
    t.querySelectorAll('tr').forEach((r) => r.children[idx] && r.children[idx].classList.add('ab-ours'));
  });
})();
